import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { SubmitStatus } from '../elements/VatDeclaration/enums/submitStatus'
import { getVatDeclarationSubmissions } from '../query-api'
import { VatDeclarationSubmission } from '../types/vatDeclarationSubmission'

const ONE_MINUTE = 60000
const REFETCH_INTERVAL_MS = 5 * ONE_MINUTE

interface UseVatDeclarationSubmissionsProps {
  ids: string
}

export const useVatDeclarationSubmissions = ({ ids }: UseVatDeclarationSubmissionsProps) => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()

  const organizationId = organization?.id || ''

  const {
    data,
    isLoading: isVatDeclarationLogsLoading,
    ...rest
  } = useQuery(
    [QueryKeys.VatDeclarationSubmission, ids, organizationId],
    () =>
      getVatDeclarationSubmissions({
        organizationId,
        salesTaxReturnIds: ids,
      }),
    {
      enabled: !!organizationId && !!ids && organization?.countryId === 'NL',
      refetchInterval: (data) => {
        const submissions = data?.salesTaxReturnSubmissions || []

        if (submissions.length === 0) {
          return REFETCH_INTERVAL_MS
        }

        const hasProcessingSubmissions = submissions.some(
          (submission: VatDeclarationSubmission) => submission.status === SubmitStatus.Processing,
        )

        return hasProcessingSubmissions ? REFETCH_INTERVAL_MS : false
      },
    },
  )

  const isLoading = isOrganizationLoading || isVatDeclarationLogsLoading

  const submissionsMap: Record<string, VatDeclarationSubmission> =
    data?.salesTaxReturnSubmissions?.reduce<Record<string, VatDeclarationSubmission>>((acc, submission) => {
      acc[submission.salesTaxReturnId] = submission
      return acc
    }, {}) ?? {}

  return { submissionsMap, isLoading, ...rest }
}
